module.exports = __webpack_public_path__ + "static/img/mode2-8.840536f2.png";